import { render, staticRenderFns } from "./InvoiceNotice.vue?vue&type=template&id=65a084fe&scoped=true"
import script from "./InvoiceNotice.vue?vue&type=script&lang=js"
export * from "./InvoiceNotice.vue?vue&type=script&lang=js"
import style0 from "./InvoiceNotice.vue?vue&type=style&index=0&id=65a084fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a084fe",
  null
  
)

export default component.exports